import { render, staticRenderFns } from "./v1Class.vue?vue&type=template&id=3e44a8b6&scoped=true&"
import script from "./v1Class.vue?vue&type=script&lang=js&"
export * from "./v1Class.vue?vue&type=script&lang=js&"
import style0 from "./v1Class.vue?vue&type=style&index=0&id=3e44a8b6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e44a8b6",
  null
  
)

export default component.exports